import type { Candidate } from '../types';
import { mockCandidatePhoto } from './mockCandidatePhoto';
import { mockCandidateResume } from './mockCandidateResume';
import { mockCandidateVacancy } from './mockCandidateVacancy';

export function mockCandidate(overrides: Partial<Candidate> = {}): Candidate {
  return {
    id: 1,
    candidateVacancyId: 1,
    phone: '+33123456789',
    status: 'NEW',
    firstName: 'John',
    lastName: 'Doe',
    age: 28,
    cityIds: [1],
    allCities: false,
    educationLevel: {
      id: 1,
      name: 'Bachelor degree',
      code: 'bachelor',
      professionName: 'Software engineer',
    },
    professionName: 'Software engineer',
    birthAt: '1998-01-15',
    preferredCommunicationLanguage: 'English',
    interviewRequired: true,
    latitude: 48.8566,
    longitude: 2.3522,
    pingEnabled: true,
    createdAt: '2026-06-01T10:00:00.000Z',
    updatedAt: '2026-07-15T12:30:00.000Z',
    rating: 4.5,
    generalInfo: 'Open to relocation and international opportunities',
    matchPercent: 85,
    matchReason: 'The candidate experience matches the vacancy requirements',
    candidateVacancyStatus: 'proposed',
    decisionType: 'PENDING',
    summary: 'Relevant experience and skills for the vacancy',
    analysis: 'The candidate is a strong match for the vacancy',
    candidateVacancyCreatedAt: '2026-07-01T09:00:00.000Z',
    resumes: [{ ...mockCandidateResume(), id: 1 }],
    vacancies: [mockCandidateVacancy()],
    photo: mockCandidatePhoto(),
    ...overrides,
  };
}
